<template>
    <div class="img_class">
      <div>
        <span v-if="isImg" class="imgVideo_classs"><div style="width:50px;background-color:rgb(124, 189, 255);color: #fff;border-radius:4px;padding-left:8px">图片<i class="el-icon-caret-right"></i></div></span>
        <span v-if="isVideo" class="imgVideo_classs"><div style="width:50px;background-color:rgb(124, 189, 255);color: #fff;border-radius:4px;padding-left:8px">视频<i class="el-icon-caret-right"></i></div></span>
      </div>
      <div v-if="isImg" class="over_pulldown" :style="{ width: (isVideo?'45%':'100%')}">
        <div v-if="img!=''" style="padding:0px 10px;position:absolute">
          <div v-for="(item,index) in img" :key="index" style="display:inline-block;margin-left:10px;position: relative;">
             <el-image z-index="2077" style="width: 150px;height:120px" :src="item" :preview-src-list="[item]">
            </el-image>
            <el-button v-if="delShow==1||delShow==2" icon="el-icon-delete" class="button_position" @click="affirm(item,'img')" size="small" circle></el-button>
          </div>
        </div>
      </div>
      <div v-if="isVideo" class="over_pulldown border_left" :style="{ width: (isImg?'45%':'100%')}">
        <div v-if="video!=''" style="padding:0px 10px;position:absolute">
          <div v-for="(item,index) in video" :key="index" style="padding:0px 10px;position: relative;display: inline-block;">
            <template>
              <video id="videos" width="150" height="120" controls>
                <source :src="item" type="video/mp4">
                <source :src="item" type="video/ogg">
                您的浏览器不支持 HTML5 video 标签。
              </video>
              <el-button v-if="delShow==1||delShow==2" icon="el-icon-delete" class="button_position" @click="affirm(item,'video')" size="small" circle></el-button>
            </template>
          </div>
        </div>
      </div>
      <el-dialog
        title="提示"
        :visible.sync="dialogVisible"
        :append-to-body="true"
        :close-on-click-modal="false"
        :show-close="false"
        width="30%">
        <span>是否删除</span>
        <span slot="footer" class="dialog-footer">
          <el-button size="small" @click="dialogVisible = false">关 闭</el-button>
          <el-button size="small" :loading="buttonLoad"  type="primary" @click="del">确 定</el-button>
        </span>
      </el-dialog>
    </div>
</template>

<script>
import { mapIp } from '@/api/debugUrl'
export default {
    name: 'imgVideo',
    data(){
      return {
        buttonLoad:false,
        img: "",
        video: [],
        ipPort:"",
        dialogVisible:false,
        delItems:'',
        delType:'',
      }
    },
    props: {
      data:{
        type:String,
        default:''
      },
      delShow:{
        // type:String,
        default:'3'
      },
      isImg:{
        type:Boolean,
        default:true
      },
      isVideo: {
        type:Boolean,
        default:true
      },
      titel: {
        type:String,
        default:''
      },
    },
    watch:{
        data(newVal,oldVal){
          let num=(newVal==null)?'':newVal;
          this.video = [];
          if(!(this.ipPort)){
            this.$http.postX(this.$url.getDict, {
                search: "图片配置URL"
            }).then(res => {
                let { data } = res;
                this.ipPort=data[0].enCode;
                this.setImgVideo(num);
            })
          }else{
            this.setImgVideo(num);
          }
        }
    },
    methods:{
      setImgVideo(newVal){
        let data=newVal;
          if (data == "" || data == null || data=="{}") {
            this.img='';
            this.video=[];
          } else {
            if(data.indexOf('img')>=0){
              let obj = JSON.parse(data);
              if(obj.img!=null){
                if(obj.img==''){
                  this.img = '';
                }else{
                  let isCommaImg = obj.img.charAt(obj.img.length - 1);
                  if (isCommaImg == ',' || isCommaImg == "，") {
                      let str = obj.img.substr(0, obj.img.length - 1);
                      let lists=str.split("," || "，");
                      for(let i in lists){
                        (lists[i].indexOf('http')<0)&&(lists[i]=this.ipPort+lists[i]);
                      }
                      this.img = lists;
                  } else {
                      let lists=obj.img.split("," || "，");
                      for(let i in lists){
                        (lists[i].indexOf('http')<0)&&(lists[i]=this.ipPort+lists[i]);
                      }
                      this.img = lists;
                  }
                }
              }
              if(obj.video!=null){
                if(obj.video==''){
                  this.video = [];
                }else{
                  let isCommaAV = obj.video.charAt(obj.video.length - 1);
                  if (isCommaAV == ',' || isCommaAV == "，") {
                      let str = obj.video.substr(0, obj.video.length - 1);
                      let lists=str.split("," || "，");
                      for(let i in lists){
                        (lists[i].indexOf('http')<0)&&(lists[i]=this.ipPort+lists[i]);
                      }
                      this.video = lists;
                  } else {
                      let lists=obj.video.split("," || "，");
                      for(let i in lists){
                        (lists[i].indexOf('http')<0)&&(lists[i]=this.ipPort+lists[i]);
                      }
                      this.video = lists;
                  }
                  document.getElementById("videos").load();
                }
              }
            }else{
              let lists=data.split("," || "，");
              let list=[];
              for(let i in lists){
                (lists[i]&&lists[i].indexOf('http')<0)&&(lists[i]=this.ipPort+lists[i]);
                (lists[i])&&(list.push(lists[i]));
              }
              this.img = list;
            }
          }
      },
      isHttp(data){
        return data
      },
      affirm(row,type){
        this.dialogVisible=true;
        this.delItems=row;
        this.delType=type;
      },
      del(){
        this.buttonLoad=true;
        let row=this.delItems;
        let types=this.delType;
        let num=row.indexOf(this.ipPort);
        let relatives=num<0?row:(row.substr(this.ipPort.length,row.length))
        if(this.data.indexOf('img')>=0){
          let obj = JSON.parse(this.data);
          let isCommaImg = obj[types].charAt(obj[types].length - 1);
          let indexs=0;
          if (isCommaImg == ',' || isCommaImg == "，") {
              let str = obj[types].substr(0, obj[types].length - 1);
              let lists=str.split("," || "，");
              for(let i in lists){
                (lists[i].indexOf(relatives)>=0)&&(indexs=i);
              }
              lists.splice(indexs,1);
              let ac=lists.join(',');
              if(ac==''){obj[types]='';}else{obj[types]=lists.join(',')+',';}
          } else {
              let lists=obj[types].split("," || "，");
              for(let i in lists){
                (lists[i].indexOf(relatives)>=0)&&(indexs=i);
              }
              lists.splice(indexs,1);
              let ac=lists.join(',');
              if(ac==''){obj[types]='';}else{obj[types]=lists.join(',')+',';}
          }
          let values=JSON.stringify(obj);
          if(this.delShow=='1'){
            this.$http.post(this.$url.deleteimages,{path:relatives}).then(res=>{
              this.$message({message: '删除成功！',type: 'success'})
              this.$emit("delImg",values);
              this.dialogVisible=false;
              this.buttonLoad=false;
            }).catch(()=>{
              this.$message({message: '删除失败,请重试！',type: 'warning'})
            })
          }else if(this.delShow=='2'){
            this.$message({message: '删除成功！',type: 'success'})
            this.$emit("delImg",values);
            this.dialogVisible=false;
            this.buttonLoad=false;
          }
        }else{
          let indexs=0;
          let lists=this.data.split("," || "，");
          for(let i in lists){
            (lists[i].indexOf(relatives)>=0)&&(indexs=i);
          }
          lists.splice(indexs,1);
          let values=lists.length>0?(lists.join(',')):"";
          if(this.delShow=='1'){
            this.$http.post(this.$url.deleteimages,{path:relatives}).then(res=>{
              this.$message({message: '删除成功！',type: 'success'})
              this.$emit("delImg",values);
              this.dialogVisible=false;
              this.buttonLoad=false;
            }).catch(()=>{
              this.$message({message: '删除失败,请重试！',type: 'warning'})
            })
          }else if(this.delShow=='2'){
            this.$message({message: '删除成功！',type: 'success'})
            this.$emit("delImg",values);
            this.dialogVisible=false;
            this.buttonLoad=false;
          }
        }
          
      },
    },
    created() {
      let num=(this.data==null)?'':this.data;
      this.$http.postX(this.$url.getDict, {
          search: "图片配置URL"
      }).then(res => {
          let { data } = res;
          this.ipPort=data[0].enCode;
          this.setImgVideo(num);
      })
    },
    updated(){
    }
  }
</script>
<style scoped>
.imgVideo_classs {
  display: inline-block;
  font-size: 14px;
  margin:10px 20px;
  width: 41%;
}
.img_class{
  margin-top: -20px;
}
.button_position{
    padding: 9px;
    position: absolute;
    z-index: 9;
    background-color: #ffffff5c;
    right: 0px;
    color: white;
    top: 88px;
    border-radius: 0%;
}

/* 滚动条样式 */
.over_pulldown::-webkit-scrollbar{
  /* display: none; */
  width: 4px;
}
/* 滚动槽 */
.over_pulldown::-webkit-scrollbar-track{
  width: 5px;
  border-radius:5px;
  box-sizing: border-box;
  /* display: none; */
}
/* 滚动条滑块 */
.over_pulldown::-webkit-scrollbar-thumb{
  border-radius: 6px;
  border-left: 8px solid rgb(124, 189, 255);
}
.over_pulldown{
  height:124px;display: inline-block;position:relative;overflow:auto;
}
.img_class .border_left{
  border-left: 1px #9292924a solid;
}
</style>
<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/components/aboutForm/imgVideo.vue"
}
</vue-filename-injector>
